const React = require('react')
const { useState, useEffect } = require('react')
const { useHistory, useLocation } = require('react-router-dom')
const { Container, Col, Row } = require('reactstrap')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { TableHeader, TableFooter } = require('@components/table')
const { TokenTransfersTable } = require('./table.tokenTransfers')

require('@styles/pages/blocks/index.css')

const TokenTransfers = () => {
    const history = useHistory()
    const location = useLocation()
    const { network } = useNetworkConfig()
    const { getTokenTransfers } = useBlockchainData(network.name)

    const params = new URLSearchParams(location.search)

    const [address, setAddress] = useState(params.get('a') ? params.get('a').toLowerCase() : null)
    const [page, setPage] = useState(Number(params.get('p')) || 1)
    const [limit, setLimit] = useState(Number(params.get('ps')) || 25)
    const [tokenTransfersData, setTokenTransfersData] = useState()

    const [loading, setLoading] = useState(false)
    const [title, setTitle] = useState('')
    const [subtitle, setSubtitle] = useState('')
    const [totalPages, setTotalPages] = useState(0)

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const addressParam = params.get('a') ? params.get('a').toLowerCase() : null
        const pageParam = Number(params.get('p'))
        const limitParam = Number(params.get('ps'))

        if (addressParam && addressParam !== address) {
            setAddress(addressParam)
        }

        if (pageParam && pageParam > 0 && pageParam !== page) {
            setPage(pageParam)
        }

        if (limitParam && limitParam > 0 && limitParam !== limit) {
            setLimit(limitParam)
        }
    }, [location.search])

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)

            try {
                const [tokenTransfersResponse] = await Promise.all([
                    getTokenTransfers(page, limit, {
                        tokenType: 'token',
                        ...(address && { userAddress: address })
                    })
                ])

                if (tokenTransfersResponse) {
                    setTokenTransfersData(tokenTransfersResponse)

                    setTitle(
                        tokenTransfersResponse.totalItems > 10_000_000
                            ? 'More than 10,000,000 transactions found'
                            : `A total of ${tokenTransfersResponse.totalItems.toLocaleString()} transaction${
                                  tokenTransfersResponse.totalItems === 1 ? '' : 's'
                              } found`
                    )

                    setSubtitle(
                        tokenTransfersResponse.totalItems > 5_000
                            ? `Showing the last ${
                                  tokenTransfersResponse.totalItems < 1000
                                      ? tokenTransfersResponse.totalItems.toLocaleString()
                                      : tokenTransfersResponse.totalItems < 5_000
                                      ? `${(tokenTransfersResponse.totalItems / 1000).toFixed(1)}k`
                                      : '5,000'
                              } records only`
                            : undefined
                    )

                    setTotalPages(
                        tokenTransfersResponse.totalItems > 5_000 ? 5_000 / limit : tokenTransfersResponse.totalPages
                    )
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [network, page, limit])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text className='page-title'>Token Transfers (ERC-20)</text>
                            {address && (
                                <div style={{ display: 'block', marginTop: '8px' }}>
                                    <text className='page-title-subcontent'>
                                        For&nbsp;
                                        <span
                                            className={`${network.name}-text-color cursor-pointer`}
                                            onClick={() => history.push(`/${network.name}/address/${address}`)}
                                        >
                                            {address}
                                        </span>
                                    </text>
                                </div>
                            )}
                            <div className='page-title-border' />
                        </div>
                    </Row>

                    <div className='box table-section' style={{ padding: '24px 24px 0' }}>
                        {loading ? (
                            <div
                                className='d-flex justify-content-center align-items-center'
                                style={{ height: '300px' }}
                            >
                                <LoadingSpinner />
                            </div>
                        ) : (
                            <>
                                <TableHeader
                                    title={title}
                                    subtitle={subtitle}
                                    page={page}
                                    limit={limit}
                                    totalPages={totalPages}
                                />
                                <TokenTransfersTable data={tokenTransfersData?.items} />
                                <TableFooter
                                    limit={limit}
                                    setLimit={setLimit}
                                    page={page}
                                    setPage={setPage}
                                    totalPages={totalPages}
                                />
                            </>
                        )}
                    </div>
                </Col>
            </Container>
        </div>
    )
}

module.exports = TokenTransfers
